import n from "../../node_modules/.pnpm/@heroicons_vue@2.0.13_vue@3.3.4/node_modules/@heroicons/vue/20/solid/esm/XMarkIcon.mjs";
import { defineComponent as s, ref as a, onMounted as i, onBeforeUnmount as u, watchEffect as p } from "vue";
import f from "../IconButton/IconButton.vue.mjs";
const d = {
  primary: "bg-primary-500",
  indigo: "bg-indigo-500",
  blue: "bg-blue-500",
  red: "bg-red-500",
  orange: "bg-orange-500",
  teal: "bg-teal-500",
  purple: "bg-purple-500",
  pink: "bg-pink-500",
  yellow: "bg-yellow-500",
  green: "bg-green-500"
}, y = s({
  name: "TuiNotification",
  components: {
    IconButton: f,
    XMarkIcon: n
  },
  inheritAttrs: !1,
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    closeable: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: null
    },
    autoClose: {
      type: Boolean,
      default: !1
    },
    closeDelay: {
      type: [String, Number],
      default: 2e3
    },
    progressColor: {
      type: String,
      default: "primary"
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:show", "hidden"],
  setup(o, { emit: l }) {
    const t = a(!1), r = () => l("update:show", !1);
    let e;
    return i(() => {
      t.value = !0, u(() => {
        clearTimeout(e);
      });
    }), p(() => {
      o.autoClose && o.show ? typeof window < "u" && (e = window.setTimeout(r, Number(o.closeDelay))) : e && clearTimeout(e);
    }), { mounted: t, close: r };
  },
  computed: {
    progressClasses() {
      return d[this.progressColor];
    },
    progressStyles() {
      return {
        animationDuration: `${this.closeDelay}ms`
      };
    }
  }
});
export {
  y as default
};
//# sourceMappingURL=Notification.vue2.mjs.map
